module.exports = __webpack_public_path__ + "img/cloud-upload-sidebar.9014c732.svg";